import { IFindParameter, IOverlay, IOverlayClusterParameter, IOverlayDelete, IOverlayParameter, IPointGeometry, IPointSymbol, IPolygonSymbol, IPolylineSymbol, IResult } from "@/types/map";
import Axios from "axios";
import ToolTipBaiDu from "./ToolTipBaiDu";
declare let BMap: any;
declare let BMapLib: any;

export class OverlayBaidu {
  private static intances: Map<string, any>;
  private view!: any;
  private overlayers = new Map<any, any>(); //所有已经添加到地图上的覆盖物,用"{type,id}"做主键
  private markerClustererLayer = new Array();
  public showGisDeviceInfo: any;
  public mouseOverMarker: any;
  private popup: any;

  private constructor(view: any) {
    this.view = view;
  }

  public static getInstance(view: any) {
    let id = view.getContainer().id;
    if (!OverlayBaidu.intances) {
      OverlayBaidu.intances = new Map();
    }
    let intance = OverlayBaidu.intances.get(id);
    if (!intance) {
      intance = new OverlayBaidu(view);
      OverlayBaidu.intances.set(id, intance);
    }
    return intance;
  }

  public static destroy() {
    (OverlayBaidu.intances as any) = null;
  }

  private getMarker(overlay: any, symbol: any): any {
    let marker: any;
    let geometry = overlay.geometry;
    let type: any = geometry.type;
    //以防万一type未定义
    if (!type) {
      if (geometry.radius) {
        type = "circle";
      } else if (geometry.x) {
        type = "point";
      } else if (geometry.paths && geometry.paths.length > 0) {
        type = "polyline";
      } else if (geometry.rings) {
        type = "polygon";
      }
    }

    switch (type) {
      case "polyline":
        let paths = typeof geometry.paths[0][0] == "number" ? geometry.paths : geometry.paths[0];
        marker = new BMap.Polyline(this.getGeometry(paths), symbol);
        break;
      case "polygon":
        let rings = typeof geometry.rings[0][0] == "number" ? geometry.rings : geometry.rings[0];
        marker = new BMap.Polygon(this.getGeometry(rings), symbol);
        break;
      case "extent":
        break;
      case "circle":
        let cp;
        if (geometry.center) {
          if (geometry.center.x && geometry.center.y) {
            cp = new BMap.Point(geometry.center.x, geometry.center.y);
          } else {
            cp = new BMap.Point(geometry.center[0], geometry.center[1]);
          }
        } else {
          cp = new BMap.Point(geometry.x, geometry.y);
        }
        marker = new BMap.Circle(cp, geometry.radius, symbol); //创建圆
        break;
      case "point":
      default:
        marker = new BMap.Marker(new BMap.Point(geometry.x, geometry.y), symbol);
        break;
    }
    return marker;
  }

  private getGeometry(points: number[][]): object[] {
    let features: object[] = [];
    for (let i = 0; i < points.length; i++) {
      let pt: number[] = points[i];
      let point = new BMap.Point(pt[0], pt[1]);
      features.push(point);
    }
    return features;
  }

  private makeSymbol(symbol: IPointSymbol | IPolylineSymbol | IPolygonSymbol | undefined): object | undefined {
    if (!symbol) return undefined;

    let marker;
    let myIcon;
    let size;
    let xoffset;
    let yoffset;

    switch (symbol.type) {
      case "polyline":
        let sfs = symbol as IPolylineSymbol;
        marker = {
          strokeColor: sfs.color,
          strokeWeight: sfs.size || sfs.width,
        };
        break;
      case "polygon":
      case "extent":
      case "circle":
        let sms = symbol as IPolygonSymbol;
        const sstyle = sms.outline.style && sms.outline.style === "solid" ? "solid" : "dashed";
        marker = {
          strokeColor: sms.outline ? sms.outline.color : sms.color,
          strokeWeight: sms.outline ? sms.outline.size || sms.outline.width || 4 : 4,
          fillColor: sms.color,
          fillOpacity: (sms as any).opacity,
          strokeStyle: sstyle,
        };
        break;
      case "point":
      default:
        let sps = symbol as IPointSymbol;
        if (sps.size) {
          size = new BMap.Size(Number(sps.size instanceof Array ? sps.size[0] : sps.size) / 0.75, Number(sps.size instanceof Array ? sps.size[1] : sps.size) / 0.75);
        }
        if (sps.width) {
          size = new BMap.Size(Number(sps.width) / 0.75, Number(sps.height) / 0.75);
        }
        xoffset = Number(sps.xoffset) / 0.75 || 0;
        yoffset = Number(sps.yoffset) / 0.75 || 0;

        myIcon = new BMap.Icon(sps.url, size, {
          imageSize: size,
        });
        //规定yoffset:正值向上偏移，负值向下偏移
        marker = { icon: myIcon, offset: new BMap.Size(xoffset, -yoffset), strokeColor: sps?.strokeColor || "blue", fillColor: sps?.fillColor || "#fff" };
        break;
    }
    return marker;
  }

  /**根据graphic的属性生成弹出框*/
  private getInfoWindowContent(graphic: any): any {
    let content = "";
    //键值对
    for (let fieldName in graphic.attributes) {
      if (graphic.attributes.hasOwnProperty(fieldName)) {
        content += "<b>" + fieldName + ": </b>" + graphic.attributes[fieldName] + "<br>";
      }
    }
    //去掉最后的<br>
    content = content.substring(0, content.lastIndexOf("<br>"));
    if (graphic.buttons !== undefined) {
      content += "<hr>";
      graphic.buttons.forEach((buttonConfig: { type: string; label: string }) => {
        content += "<button type='button' class='btn btn-primary btn-sm' onclick='mapFeatureClicked(" + '"' + buttonConfig.type + '", "' + graphic.id + '"' + ")'>" + buttonConfig.label + "</button>  ";
      });
    }
    return content;
  }

  private getPopUpHtml(graphic: any, content: string): any {
    let tipContent = content;
    for (let fieldName in graphic.attributes) {
      if (graphic.attributes.hasOwnProperty(fieldName)) {
        tipContent = tipContent.replace(new RegExp("{" + fieldName + "}", "g"), graphic.attributes[fieldName]);
      }
    }
    return tipContent;
  }

  private _showGisDeviceInfo(type: string, id: string, detail: any) {
    if (this.showGisDeviceInfo) {
      this.showGisDeviceInfo(type, id, detail);
    }
  }

  private _mouseOverMarker(event: any, type: string, id: string, detail: any) {
    if (this.mouseOverMarker) {
      this.mouseOverMarker(event, type, id, detail);
    }
  }

  private async translatePoint(overlays: IOverlay[], coord: string): Promise<any> {
    let fromCoord = "1";

    if (coord == "GCJ02") {
      fromCoord = "3";
    }
    let _this = this;
    let queryLen = 80; //坐标转换最大数
    let features = "";
    let promises = new Array();
    let points = overlays;
    let count = 0;
    let featuresArr = Array();
    let feaureStr = "";
    for (let i = 0; i < points.length; i++) {
      let pt = points[i];
      if (pt.geometry && pt.geometry.hasOwnProperty("x")) {
        if (count == queryLen) {
          featuresArr.push(feaureStr);
          feaureStr = (pt.geometry as IPointGeometry).x + "," + (pt.geometry as IPointGeometry).y + ";";
          count = 1;
        } else {
          feaureStr = feaureStr + (pt.geometry as IPointGeometry).x + "," + (pt.geometry as IPointGeometry).y + ";";
          count++;
        }
      }
    }
    if (feaureStr != "") {
      featuresArr.push(feaureStr);
    }
    let bdPoints: any[] = [];
    for (let j = 0; j < featuresArr.length; j++) {
      features = featuresArr[j];
      let res = await Axios.get("http://" + _this.view.gisServer + "/geoconv?coords=" + features + "&from=" + fromCoord + "&to=5&output=json");
      bdPoints = bdPoints.concat(res.data.results);
    }
    overlays.forEach((overlay: IOverlay, index: number) => {
      if (overlay.geometry && overlay.geometry.hasOwnProperty("x")) {
        (overlay.geometry as IPointGeometry).x = bdPoints[index].x;
        (overlay.geometry as IPointGeometry).y = bdPoints[index].y;
      }
    });
    return overlays;
  }

  public getCenter(geometry: any) {
    if (geometry instanceof BMap.Marker) {
      return geometry.getPosition();
    } else {
      return geometry.getBounds().getCenter();
    }
  }

  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    const _this = this;
    const defaultSymbol = this.makeSymbol(params.defaultSymbol);
    const showPopup = params.showPopup;
    const defaultInfoTemplate = params.defaultInfoTemplate;
    const autoPopup = params.autoPopup;
    const showToolTip = params.showToolTip;
    const defaultType = params.type;
    const toolTipContent = params.toolTipContent;
    const defaultButtons = params.defaultButtons;
    const defaultVisible = params.defaultVisible !== false;
    const coords = params.coords;
    const popupComponent = params.popupComponent;
    const centerResult = params.centerResult === true;

    const custom = params.custom;

    if (showToolTip) {
      //this.MoveToolTip(toolTipContent);
    }

    let addCount = 0;
    if (coords) {
      params.overlays = await this.translatePoint(params.overlays, coords.toLocaleUpperCase());
    }
    let points: any[] = [];
    let allpoints: any[] = []; //用于调整地图视角以包含所有添加的地图覆盖物
    for (let i = 0; i < params.overlays.length; i++) {
      const overlay = params.overlays[i];
      const overlaySymbol = this.makeSymbol(overlay.symbol);
      const fields = overlay.fields;
      const buttons = overlay.buttons || defaultButtons;
      let graphic = this.getMarker(overlay, overlaySymbol || defaultSymbol);
      ///将相关的属性直接放入百度地图的overlay中
      graphic.attributes = fields || { type: "" };
      graphic.buttons = buttons;
      graphic.id = overlay.id;
      graphic.type = overlay.type || defaultType;
      graphic.attributes.type = graphic.type; //指定的属性字段
      //自定义的几何数据
      if (graphic instanceof BMap.Marker) {
        let geo = {
          x: graphic.getPosition().lng,
          y: graphic.getPosition().lat,
          longitude: graphic.getPosition().lng,
          latitude: graphic.getPosition().lat,
          type: "point",
        };
        graphic.geometry = geo;
      }

      if (!defaultVisible) {
        graphic.hide();
      }

      if (custom) {
        let label = new BMap.Label(this.getPopUpHtml(graphic, custom.content), {
          position: this.getCenter(graphic),
          offset: new BMap.Size(0, 0),
        }); // 创建文本标注对象
        label.setStyle({
          fontSize: custom.fontSize || "14px",
          color: custom.fontColor || "red",
          border: "0px",
          background: "none",
          fontFamily: "微软雅黑",
        });
        label.id = overlay.id;
        label.type = overlay.type || defaultType;
        this.view.addOverlay(label);
      }
      let mapView = this.view;
      let title: any;
      let content: string = "";
      if (defaultInfoTemplate === undefined) {
        content = this.getInfoWindowContent(graphic);
      } else {
        title = defaultInfoTemplate.title;
        content = this.getPopUpHtml(graphic, defaultInfoTemplate.content);
      }
      if (autoPopup) {
        let infoWindow = new BMap.InfoWindow(content, {
          //width : 270,     // 信息窗口宽度
          //height: 50,     // 信息窗口高度
          title: title, // 信息窗口标题
          enableMessage: true, //设置允许信息窗发送短息
          message: "",
        });
        graphic.isOpenInfo = true;
        this.view.openInfoWindow(infoWindow, graphic.point);
      }
      let _this = this;

      if (params.triggerClick !== false) {
        graphic.addEventListener(
          "click",
          function (e: any) {
            if (showPopup) {
              if (popupComponent) {
                if (_this.popup) {
                  _this.popup.remove();
                  _this.popup = null;
                }
                _this.popup = new ToolTipBaiDu(_this.view, popupComponent, {}, e.point, e.target.attributes);
              }
            }
            if (defaultInfoTemplate) {
              let infoWindow = new BMap.InfoWindow(content, {
                // width: 0, // 信息窗口宽度
                // height: 0, // 信息窗口高度
                title: title, // 信息窗口标题
                enableMessage: true, //设置允许信息窗发送短息
                message: "",
              }); // 创建信息窗口对象
              e.target.isOpenInfo = true;
              mapView.openInfoWindow(infoWindow, e.point);
            }
            _this._showGisDeviceInfo(e.target.type, e.target.id, {
              attributes: e.target.attributes,
              geometry: e.target.geometry,
            });
          },
          true
        );
      }

      if (params.triggerMouseover !== false) {
        graphic.addEventListener("mouseover", (e: any) => {
          e.type = "mouseover";
          let center: any;
          if (graphic instanceof BMap.Marker || graphic instanceof BMap.Label || graphic instanceof BMap.Hotspot) {
            center = graphic.getPosition();
          } else {
            center = graphic.getPath()[0];
          }
          const pixel = this.view.pointToPixel(center);
          e.screenPoint = pixel;
          e.native = { offsetX: e.pixel.x, offsetY: e.pixel.y };
          //拿到geometry
          _this._mouseOverMarker(e, e.target.type, e.target.id, {
            attributes: e.target.attributes,
            geometry: e.target.point,
          });
        });
      }

      if (params.triggerMouseout !== false) {
        graphic.addEventListener("mouseout", (e: any) => {
          e.type = "mouseout";
          //拿到geometry
          _this._mouseOverMarker(e, e.target.type, e.target.id, {
            attributes: e.target.attributes,
            geometry: e.target.point,
          });
        });
      }

      points.push(graphic);

      //添加覆盖物，并保证type+id的唯一性
      const oly_key = JSON.stringify({ id: graphic.id, type: graphic.type });
      if (this.overlayers.has(oly_key)) {
        this.view.removeOverlay(this.overlayers.get(oly_key));
      }
      this.overlayers.set(oly_key, graphic);
      this.view.addOverlay(graphic);
      addCount++;

      //存入坐标点到allpoints
      if (graphic instanceof BMap.Marker) {
        allpoints.push(graphic.getPosition());
      } else if (graphic instanceof BMap.Circle) {
        //对于圆形则存入包围盒的西南、东北角
        //@notice graphic在调用view.addOverlay之前是没有Bounds的
        allpoints.push(graphic.getBounds().getSouthWest());
        allpoints.push(graphic.getBounds().getNorthEast());
      } else {
        allpoints = allpoints.concat(graphic.getPath());
      }

      //@notice这个地方和后面allpoints的目的重复了
      if (params.overlays.length === 1 && centerResult) {
        if (graphic instanceof BMap.Polygon) {
          const bounds = graphic.getBounds();
          const center = bounds.getCenter();
          let viewpoint = this.view.getViewport(graphic.getPath());
          await this.view.centerAndZoom(viewpoint.center, viewpoint.zoom);
        } else if (graphic instanceof BMap.Polyline) {
          const bounds = graphic.getBounds();
          const center = bounds.getCenter();
          let viewpoint = this.view.getViewport(graphic.getPath());
          await this.view.centerAndZoom(viewpoint.center, viewpoint.zoom);
        } else if (graphic instanceof BMap.Marker) {
          const center = graphic.getPosition();
          await this.view.centerAndZoom(center, 14);
        } else if (graphic instanceof BMap.Circle) {
          const bounds = graphic.getBounds();
          const center = bounds.getCenter();
          let vp = this.view.getViewport(bounds);
          this.view.setViewport(bounds);
        }
      }
    }
    if (centerResult) {
      let viewpoint = this.view.getViewport(allpoints);
      await this.view.setViewport(viewpoint);
    }
    return {
      status: 0,
      message: "ok",
      result: params.overlays,
    };
  }
  public async findFeature(params: IFindParameter) {
    let type = params.layerName;
    let ids = params.ids || [];
    let level = params.level || this.view.getZoom();
    let overlays: any[] = this.view.getOverlays();
    let centerResult = params.centerResult !== false;
    overlays.forEach(overlay => {
      if (type == overlay.type && ids.indexOf(overlay.id) >= 0) {
        if (centerResult) {
          let center = overlay.getPosition();
          if (center.lat !== null && center.lng !== null) {
            this.view.centerAndZoom(center, level);
          }
        }
        overlay.setAnimation(2);
        setTimeout(function () {
          overlay.setAnimation(0);
        }, 3600);
      }
    });
    return {
      status: 0,
      message: "ok",
    };
  }

  public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
    const _this = this;

    const defaultType = params.type;
    const zoom = params.zoom;
    const distance = params.distance;
    const defaultSymbol = this.makeSymbol(params.defaultSymbol);
    const defaultVisible = params.defaultVisible;
    const defaultTooltip = params.defaultTooltip;
    const defaultInfoTemplate = params.defaultInfoTemplate;
    const showPopup = params.showPopup;
    const coords = params.coords;
    const fontSize = params.textStyle?.fontSize || 10;
    const fontColor = params.textStyle?.color || "black";
    const clusterSymbol = params.clusterSymbol || params.defaultSymbol;
    const clusterImage = clusterSymbol ? clusterSymbol.url : "assets/image/m0.png";
    let clusterSize = clusterSymbol && clusterSymbol.width ? new BMap.Size(Number(clusterSymbol.width) / 0.75, Number(clusterSymbol.height) / 0.75) : new BMap.Size(53, 53);
    const cluster_bgi_size = clusterSymbol?.size;
    const textStyle = params.textStyle;
    let textContent = undefined;
    if (textStyle) {
      textContent = this._setStyleOfClusterTxt(textStyle);
      //调整cluster的高度
      clusterSize.height = clusterSize.height + Number(textStyle.fontSize + 1);
    }

    let points = params.points || params.overlays || [];
    if (coords) {
      points = await this.translatePoint(points, coords.toLocaleUpperCase());
    }
    let markers = new Array();

    for (let i = 0; i < points.length; i++) {
      const overlay = points[i];
      const overlaySymbol = this.makeSymbol(overlay.symbol);
      const fields = overlay.fields || {};
      let graphic = this.getMarker(overlay, overlaySymbol || defaultSymbol);

      graphic.attributes = fields;
      graphic.id = overlay.id;
      graphic.type = overlay.type || defaultType;
      graphic.isCluster = true;

      let mapView = this.view;
      let title: any;
      let content: string = "";

      graphic.addEventListener("click", (e: any) => {
        if (showPopup) {
          if (defaultInfoTemplate === undefined) {
            content = this.getInfoWindowContent(graphic);
          } else {
            title = defaultInfoTemplate.title;
            content = this.getPopUpHtml(graphic, defaultInfoTemplate.content);
          }
          graphic.popup = { title, content };
          let infoWindow = new BMap.InfoWindow(content, {
            // width: 0, // 信息窗口宽度
            // height: 0, // 信息窗口高度
            title: title, // 信息窗口标题
            enableMessage: true, //设置允许信息窗发送短息
            message: "",
          }); // 创建信息窗口对象
          e.target.isOpenInfo = true;
          mapView.openInfoWindow(infoWindow, e.point);
        }
        _this._showGisDeviceInfo(e.target.type, e.target.id, {
          attributes: e.target.attributes,
        });
      });

      graphic.addEventListener("mouseover", (e: any) => {
        e.type = "mouseover";
        const center = graphic.getPosition();
        const pixel = this.view.pointToPixel(center);
        e.screenPoint = pixel;
        e.native = { offsetX: e.pixel.x, offsetY: e.pixel.y };
        //拿到geometry
        _this._mouseOverMarker(e, e.target.type, e.target.id, {
          attributes: e.target.attributes,
          geometry: e.target.point,
        });
      });

      graphic.addEventListener("mouseout", (e: any) => {
        e.type = "mouseout";
        //拿到geometry
        _this._mouseOverMarker(e, e.target.type, e.target.id, {
          attributes: e.target.attributes,
          geometry: e.target.point,
        });
      });

      // if (showPopup) {
      //   if (defaultInfoTemplate === undefined) {
      //     content = this.getInfoWindowContent(graphic);
      //   } else {
      //     title = defaultInfoTemplate.title;
      //     content = this.getPopUpHtml(graphic, defaultInfoTemplate.content);
      //   }
      //   graphic.popup = { title, content };
      //   graphic.addEventListener("click", function(e: any) {
      //     let infoWindow = new BMap.InfoWindow(content, {
      //       // width: 0, // 信息窗口宽度
      //       // height: 0, // 信息窗口高度
      //       title: title, // 信息窗口标题
      //       enableMessage: true, //设置允许信息窗发送短息
      //       message: "",
      //     }); // 创建信息窗口对象
      //     e.target.isOpenInfo = true;
      //     mapView.openInfoWindow(infoWindow, e.point);
      //     _this._showGisDeviceInfo(e.target.type, e.target.id, {
      //       attributes: e.target.attributes,
      //     });
      //     graphic._showGisDeviceInfo = _this._showGisDeviceInfo;
      //   });
      // }
      markers.push(graphic);
    }

    let markerClusterer = new BMapLib.MarkerClusterer(this.view, {
      markers: markers,
      styles: [
        {
          url: clusterImage,
          size: clusterSize,
          iconSize: cluster_bgi_size,
          textSize: fontSize,
          textColor: fontColor,
        },
      ],
      customContent: textContent,
      maxZoom: zoom,
      gridSize: distance,
    });
    markerClusterer.type = defaultType;
    this.markerClustererLayer.push(markerClusterer);
    return {
      status: 0,
      message: "ok",
    };
  }

  public async deleteAllOverlays() {
    // let alloverlays = this.view.getOverlays();
    // let overlays = [].concat(alloverlays);
    // if (overlays.length > 0) {
    //   for (let i = 0; i < overlays.length; i++) {
    //     this.view.removeOverlay(overlays[i]);
    //   }
    // }
    this.view.clearOverlays();
    this.view.closeInfoWindow();
    this.overlayers.clear();
  }

  public async deleteOverlays(params: IOverlayDelete) {
    let types = params.types || [];
    let ids = params.ids || [];
    let alloverlays = this.view.getOverlays();
    let overlays = [].concat(alloverlays);
    overlays.forEach((graphic: any) => {
      if (
        //只判断type
        (types.length > 0 && ids.length === 0 && types.indexOf(graphic.type) >= 0) ||
        //只判断id
        (types.length === 0 && ids.length > 0 && ids.indexOf(graphic.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 && ids.length > 0 && types.indexOf(graphic.type) >= 0 && ids.indexOf(graphic.id) >= 0)
      ) {
        this.view.removeOverlay(graphic);
        const oly_key = JSON.stringify({ id: graphic.id, type: graphic.type });
        this.overlayers.delete(oly_key);

        if (graphic.isOpenInfo === true) {
          this.view.closeInfoWindow();
        }
        return false;
      }
      return true;
    });
  }

  public async hideOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlays = this.view.getOverlays();
    let types = params.types || [];
    let ids = params.ids || [];

    let hideCount = 0;
    overlays.forEach((overlay: any) => {
      if (
        //只判断type
        (types.length > 0 && ids.length === 0 && types.indexOf(overlay.type) >= 0) ||
        //只判断id
        (types.length === 0 && ids.length > 0 && ids.indexOf(overlay.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 && ids.length > 0 && types.indexOf(overlay.type) >= 0 && ids.indexOf(overlay.id) >= 0)
      ) {
        overlay.hide();
        if (overlay.isOpenInfo === true) {
          this.view.closeInfoWindow();
        }
        hideCount++;
      }
    });
    return {
      status: 0,
      message: "成功调用改方法！",
      result: `成功隐藏${hideCount}个覆盖物`,
    };
  }
  public async showOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlays = this.view.getOverlays();
    let types = params.types || [];
    let ids = params.ids || [];

    let showCount = 0;
    overlays.forEach((overlay: any) => {
      if (
        //只判断type
        (types.length > 0 && ids.length === 0 && types.indexOf(overlay.type) >= 0) ||
        //只判断id
        (types.length === 0 && ids.length > 0 && ids.indexOf(overlay.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 && ids.length > 0 && types.indexOf(overlay.type) >= 0 && ids.indexOf(overlay.id) >= 0)
      ) {
        overlay.show();
        showCount++;
      }
    });
    return {
      status: 0,
      message: "成功调用改方法！",
      result: `成功显示${showCount}个覆盖物`,
    };
  }
  public async deleteOverlaysCluster(params: IOverlayDelete) {
    let types = params.types || [];
    if (this.markerClustererLayer && this.markerClustererLayer.length > 0) {
      this.markerClustererLayer.forEach(layer => {
        if (types.indexOf(layer.type) >= 0) {
          layer.clearMarkers();
        }
      });
    }
    this.view.closeInfoWindow();
  }
  public async deleteAllOverlaysCluster() {
    if (this.markerClustererLayer && this.markerClustererLayer.length > 0) {
      this.markerClustererLayer.forEach(layer => {
        layer.clearMarkers();
      });
    }
    this.view.closeInfoWindow();
  }
  public getClustererLayer() {
    return this.markerClustererLayer;
  }

  //只实现了根据types查询overlay
  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlays = this.view.getOverlays();
    let targets: Array<any> = [];
    let types = new Set();
    if (typeof params.types == "string") {
      types.add(params.types);
    } else {
      types = new Set(params.types);
    }
    overlays.forEach((overlay: any) => {
      if (types.has(overlay.type as string)) {
        let id = overlay.id;
        let name = overlay.attributes?.name || overlay.name;
        let type = overlay.type || overlay.attributes?.type;
        let unidata = { id: id, name: name, type: type };
        let geo = { x: overlay.point.lng, y: overlay.point.lat };
        targets.push({ uniData: unidata, geometry: geo });
      }
    });
    return {
      status: 0,
      message: "ok",
      result: { overlays: targets },
    };
  }

  private _setStyleOfClusterTxt(textStyle: any): any {
    let textContent = "<div class='clusterText'";
    //color的格式[r,g,b] => rgb(,,)  [r,g,b,a]=>rgba(,,,)
    if (textStyle.color instanceof Array) {
      if (textStyle.color.length == 3) {
        textStyle.color = "rgb(" + textStyle.color[0] + "," + textStyle.color[1] + "," + textStyle.color[2] + ")";
      } else if (textStyle.color.length == 4) {
        textStyle.color = "rgba(" + textStyle.color[0] + "," + textStyle.color[1] + "," + textStyle.color[2] + "," + textStyle.color[3] + ")";
      }
    }

    if (textStyle.borderColor instanceof Array) {
      if (textStyle.borderColor.length == 3) {
        textStyle.borderColor = "rgb(" + textStyle.borderColor[0] + "," + textStyle.borderColor[1] + "," + textStyle.borderColor[2] + ")";
      } else if (textStyle.borderColor.length == 4) {
        textStyle.borderColor = "rgba(" + textStyle.borderColor[0] + "," + textStyle.borderColor[1] + "," + textStyle.borderColor[2] + "," + textStyle.borderColor[3] + ")";
      }
    }

    if (textStyle.backgroundColor instanceof Array) {
      if (textStyle.backgroundColor.length == 3) {
        textStyle.backgroundColor = "rgb(" + textStyle.backgroundColor[0] + "," + textStyle.backgroundColor[1] + "," + textStyle.backgroundColor[2] + ")";
      } else if (textStyle.backgroundColor.length == 4) {
        textStyle.backgroundColor = "rgba(" + textStyle.backgroundColor[0] + "," + textStyle.backgroundColor[1] + "," + textStyle.backgroundColor[2] + "," + textStyle.backgroundColor[3] + ")";
      }
    }

    if (!textStyle.borderSize) {
      textStyle.borderSize = 0;
    }

    let t_style =
      "font-size: " +
      textStyle.fontSize +
      "px;" +
      "color:" +
      textStyle.color +
      ";" +
      "height:" +
      Number(textStyle.fontSize + 5) +
      "px;" +
      "line-height: initial;" +
      "border: solid;" +
      "border-width:" +
      textStyle.borderSize +
      "px;" +
      "border-color:" +
      textStyle.borderColor +
      ";" +
      "background-color:" +
      textStyle.backgroundColor +
      ";";
    textContent = textContent + "style='" + t_style + "'>";
    return textContent;
  }
}
